import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        redirect: '/',
        children: [
            {
                path: "/",
                name: "Home",
                component: () => import('@/views/Home/Home.vue'),
                meta: { title: "首页", icon: "page" },
            },
            {
                path: "/login",
                name: "Login",
                component: () => import('@/views/Login/Login.vue'),
                meta: { title: "登录", icon: "page" },
            },
            {
                path: "/register",
                name: "Register",
                component: () => import('@/views/Register/Register.vue'),
                meta: { title: "注册", icon: "page" },
            },
            {
                path: "/about",
                name: "About",
                component: () => import('@/views/About/About.vue'),
                meta: { title: "关于我们", icon: "page" },
            },
            {
                path: "/goods/:id/:title",
                name: "Goods",
                component: () => import('@/views/Goods/Goods.vue'),
                meta: { title: "产品", icon: "page" },
            },
            {
                path: "/contact",
                name: "Contact",
                component: () => import('@/views/Contact/Contact.vue'),
                meta: { title: "联系我们", icon: "page" },
            },
            {
                path: "/search/:name",
                name: "Search",
                component: () => import('@/views/Search/Search.vue'),
                meta: { title: "搜索结果", icon: "page" },
            },
            {
                path: "/cart",
                name: "Cart",
                component: () => import('@/views/Cart/Cart.vue'),
                meta: { title: "购物车", icon: "page" },
            },
            {
                path: "/checkout/:ids",
                name: "Checkout",
                component: () => import('@/views/Checkout/Checkout.vue'),
                meta: { title: "提交订单", icon: "page" },
            },
            {
                path: "/privacy",
                name: "Privacy",
                component: () => import('@/views/Policy/Privacy.vue'),
                meta: { title: "隐私政策", icon: "page" },
            },
            {
                path: "/terms",
                name: "Terms",
                component: () => import('@/views/Policy/Terms.vue'),
                meta: { title: "条款政策", icon: "page" },
            },
            {
                path: "/refund",
                name: "Refund",
                component: () => import('@/views/Policy/Refund.vue'),
                meta: { title: "退款政策", icon: "page" },
            },
            {
                path: "/shipping",
                name: "Shipping",
                component: () => import('@/views/Policy/Shipping.vue'),
                meta: { title: "运输政策", icon: "page" },
            },
            {
                path: "/profile",
                name: "Profile",
                component: () => import('@/views/Profile/Profile.vue'),
                meta: { title: "人物", icon: "page" },
            },
            {
                path: "/goodsDetail/:id",
                name: "GoodsDetail",
                component: () => import('@/views/GoodsDetail/GoodsDetail.vue'),
                meta: { title: "商品详情", icon: "page" },
            },
            {
                path: "/payment",
                name: "PayMent",
                component: () => import('@/views/PayMent/PayMent.vue'),
                meta: { title: "支付详情", icon: "page" },
            },
            {
                path: "/paymentSuccess",
                name: "PayMentSuccess",
                component: () => import('@/views/PayMent/PayMentSuccess.vue'),
                meta: { title: "支付成功", icon: "page" },
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory("/"),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }  // 强制滚动到顶部
    }
})


// 添加全局前置守卫
router.beforeEach((to, from, next) => {
    next()
})

export default router